import PropTypes from "prop-types"
import React, { use, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { dateFormat, formatDateToISO } from "pages/Common"
import Flatpickr from "react-flatpickr";
import LeadTaskPieChart from "./LeadTaskPieChart"
import OtherTaskPieChart from "./OtherTaskPieChart"
import Select from "react-select";
import { exportDataExcel } from "components/Common/ExportData"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "35px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

let model1 = false
function TaskChartReport() {
    document.title = `Task Report | Raja Rani Couture`
    let { pathname } = useLocation()
    const flatpickrRef = useRef(null);
    const { deleteApi, getApi, postApi, putApi } = useApi()

    // useStates
    const [key, setKey] = useState([])
    const [colors, setColors] = useState([])
    const [reportData, setReportData] = useState([])
    const [value, setValue] = useState([])
    const [screenLoad, setScreenLoad] = useState(false)
    const [userControls, setUserControls] = useState([])
    const [userFilter, setUserFilter] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [task, setTask] = useState(true)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                // options.unshift({
                //     label: "Select user",
                //     value: 0,
                // });
                setUserControls(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

    }, [])

    // task-title list api
    const taskListReportApi = () => {
        setScreenLoad(true)
        postApi("Task/report", {
            UserId: userFilter?.length == 1 ? userFilter[0]?.value : 0,
            // UserId: userFilter?.map(item => item.value).join(','),
            fromDate: dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            IsLead: task
        }).then(({ data, status }) => {
            if (status === 200) {
                setReportData((task && data[1]?.Value != 0 && data[2]?.Value != 0) ? data : [])
                let Keys = []
                let Colors = []
                if (task) {
                    Keys = data.map(item => item.Key == "PendingTarget" ? "Pending Target" : "Achieved Target");
                    Colors = data.map(item => item.Key == "PendingTarget" ? "--bs-danger" : "--bs-success");
                } else {
                    Keys = data.map(item => item.Key == '1' ? "Assigned" : item.Key == '2' ? "In-Progress" : item.Key == '3' ? "Done" : item.Key == '4' ? "Discard" : "Other");
                    Colors = data.map(item => item.Key == '1' ? "--bs-primary" : item.Key == '2' ? "--bs-warning" : item.Key == '3' ? "--bs-success" : item.Key == '4' ? "--bs-danger" : "--bs-primary");
                }
                const values = data.map(item => item.Value);
                setKey(Keys);
                setColors(Colors);
                setValue(values.length == 0 ? [0, 0] : values);
                setScreenLoad(false)
            } else {
                setScreenLoad(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    // task-report api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined && userFilter?.length == 1) {
            taskListReportApi()
        } else {
            setValue([0, 0]);
        }
    }, [userFilter, dateFilter, task])

    function writeDataToExcel() {
        if (userFilter.length == 0) {
            toast.error("Please Select user", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setScreenLoad(true)
            let leadTaskHeader = ["Username", "Pending Target", "Achieved Target", "Total"];
            let otherTaskHeader = ["Username", "Assigned", "In-Progress", "Done", "Discard", "Total"];
            const mainTitle = "Task Report";
            const widthObj = [{
                Key: "A",
                Value: 20,
            },
            {
                Key: "B",
                Value: 15,
            },
            {
                Key: "C",
                Value: 15,
            },
            {
                Key: "D",
                Value: 15,
            },
            {
                Key: "E",
                Value: 15,
            },
            {
                Key: "F",
                Value: 15,
            },
            ]
            const extention = "Task_Report.xlsx"
            let excelSheetData = []

            postApi("Task/user-filter-report", {
                UserIds: userFilter?.map(item => item.value).join(','),
                fromDate: dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                IsLead: task
            }).then(({ data, status }) => {
                if (status === 200) {
                    if (data.length == 0) {
                        toast.error('No Record Found', {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        let totalPendingTarget = 0;
                        let totalAchievedTarget = 0;
                        let totalAssigned = 0;
                        let totalInProgress = 0;
                        let totalDone = 0;
                        let totalDiscard = 0;
                        for (let index = 0; index < data?.length; index++) {
                            const item = data[index];
                            let leadDataObj = {
                                Username: item?.Username,
                                PendingTarget: item?.PendingTarget,
                                AchievedTarget: item?.AchievedTarget,
                                total: (item?.AchievedTarget + item?.PendingTarget) || 0,
                            }
                            let otherDataObj = {
                                Username: item?.Username,
                                Assigned: item?.Assigned,
                                InProgress: item?.InProgress,
                                Done: item?.Done,
                                Discard: item?.Discard,
                                total: (item?.Assigned + item?.InProgress + item?.Done + item?.Discard) || 0,
                            }
                            excelSheetData.push(task ? leadDataObj : otherDataObj)
                        }
                        var fields = Object.keys(excelSheetData[0]);
                        var sheetData = excelSheetData.map(function (row) {
                            return fields.map(function (fieldName) {
                                return row[fieldName];
                            });
                        });
                        sheetData.unshift(task ? leadTaskHeader : otherTaskHeader);
                        exportDataExcel(sheetData, mainTitle, widthObj, extention)
                    }
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
            setScreenLoad(false)
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <Row>
                            <Col md="3" className="table-header" >
                                <FormGroup className="mb-2">
                                    <Select
                                        unstyled
                                        isMulti
                                        styles={colourStyles}
                                        value={userFilter}
                                        onChange={(e) => {
                                            setUserFilter(e)
                                        }}
                                        options={userControls}
                                        className="select2-selection"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4} className="">
                                <FormGroup className="mb-2">
                                    <div className="d-flex" >
                                        <Flatpickr
                                            ref={flatpickrRef}
                                            className="form-control d-block"
                                            placeholder="dd M,yyyy"
                                            options={{
                                                mode: "range",
                                                dateFormat: "d-m-Y"
                                            }}
                                            value={dateFilter}
                                            onChange={(e) => { setDateFilter(e) }}

                                        />
                                        <i
                                            className="fas fa-calendar-alt calander-icon"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                flatpickrRef.current.flatpickr.open();
                                            }}
                                        ></i>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <div style={{ marginTop: "1px" }}>
                                    <div className=" d-flex gap-2">
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value={true}
                                                id="male"
                                                // name="gender"
                                                className="form-check-input"
                                                checked={task}
                                                onClick={() => { setTask(true) }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13 me-3" htmlFor="male">
                                            Lead Task
                                        </Label>
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value={false}
                                                id="female"
                                                // name="gender"
                                                className="form-check-input"
                                                checked={!task}
                                                onClick={() => { setTask(false) }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13" htmlFor="female">
                                            Other Task
                                        </Label>
                                    </div>
                                </div>
                            </Col>
                            <Col md={2}>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-excel  btn-label"
                                        onClick={writeDataToExcel}
                                    >
                                        Excel <i className="far fa-file-excel label-icon"></i>
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={12} className="mt-2">
                                {task ?
                                    <LeadTaskPieChart dataColors='["--bs-danger","--bs-success"]' Key={key} Value={value} userFilter={userFilter} dateFilter={dateFilter} />
                                    :
                                    <OtherTaskPieChart dataColors={JSON.stringify(colors)} Key={key} Value={value} userFilter={userFilter} dateFilter={dateFilter} />
                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        </div >
    )
}
TaskChartReport.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default TaskChartReport
